import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";
import CustomTextField from "../../GRI300/GRI308/CustomTextField";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI417_1 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    productLabelingInfoRequirements: {
      componentSourcingDetails: "",
      contentImpactDetails: "",
      safeUsageGuidelines: "",
      disposalInstructions: "",
      other: "",
    },

    complianceRateProductCategories: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data = response.data.data.GRI400?.requirmentsOfProduct || {};
        setFormData({
          productLabelingInfoRequirements: {
            componentSourcingDetails:
              data.productLabelingInfoRequirements?.componentSourcingDetails ||
              "",
            safeUsageGuidelines:
              data.productLabelingInfoRequirements?.safeUsageGuidelines || "",
            contentImpactDetails:
              data.productLabelingInfoRequirements?.contentImpactDetails || "",
            disposalInstructions:
              data.productLabelingInfoRequirements?.disposalInstructions || "",
            other: data.productLabelingInfoRequirements?.other || "",
          },
          complianceRateProductCategories:
            data.complianceRateProductCategories || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    // Validate required fields in the formData
    // if (!formData.productLabelingInfoRequirements.componentSourcingDetails) {
    //   newErrors.componentSourcingDetails = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.productLabelingInfoRequirements.contentImpactDetails) {
    //   newErrors.contentImpactDetails = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.productLabelingInfoRequirements.safeUsageGuidelines) {
    //   newErrors.safeUsageGuidelines = "This field is required";
    //   formIsValid = false;
    // }

    // if (!formData.productLabelingInfoRequirements.disposalInstructions) {
    //     newErrors.disposalInstructions = "This field is required";
    //     formIsValid = false;
    //   }

    // if (!formData.complianceRateProductCategories) {
    //   newErrors.complianceRateProductCategories = "This field is required";
    //   formIsValid = false;
    // } else
    if (
      isNaN(formData.complianceRateProductCategories) ||
      Number(formData.complianceRateProductCategories) < 0 ||
      Number(formData.complianceRateProductCategories) > 100
    ) {
      newErrors.complianceRateProductCategories =
        "Please enter a valid percentage (0-100)";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return; // Validate form before submission
      const payload = {
        type: "GRI400",
        submitted417_1: true,
        requirmentsOfProduct: {
          ...formData,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/417-2/${id}`);
      } catch (error) {
        console.error("Error updating data:", error);
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/417-2/${id}`);
    }
  };

  const renderContent = ({hide}) => (
     <>
      {!hide && <p className={styles.section_heading} style={{ marginBottom: hide ? "-1rem" : "0" }}>417 : Marketing & Labelling</p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "0" }}>
        417-1 : Requirements of product and service information and labelling
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}

        <SectionHeading text="a. Does the organization's procedures for product and service information and labelling require the following types of information:" />

        <Box sx={{ marginLeft: "1rem" }}>
          <SectionHeading text="i. Details regarding the sourcing of components used in the product or service?" />
          <CustomTextField
            value={
              formData.productLabelingInfoRequirements.componentSourcingDetails
            }
            onChange={(e) =>
              handleNestedInputChange(
                "productLabelingInfoRequirements",
                "componentSourcingDetails",
                e.target.value
              )
            }
            error={errors.componentSourcingDetails}
            helperText={errors.componentSourcingDetails}
            disabled={disabled}
          />

          <SectionHeading text="ii. Information about the content, specifically substances that may have environmental or social impacts?" />
          <CustomTextField
            value={
              formData.productLabelingInfoRequirements.contentImpactDetails
            }
            onChange={(e) =>
              handleNestedInputChange(
                "productLabelingInfoRequirements",
                "contentImpactDetails",
                e.target.value
              )
            }
            error={errors.contentImpactDetails}
            helperText={errors.contentImpactDetails}
            disabled={disabled}
          />

          <SectionHeading text="iii. Guidelines for the safe usage of the product or service?" />
          <CustomTextField
            value={formData.productLabelingInfoRequirements.safeUsageGuidelines}
            onChange={(e) =>
              handleNestedInputChange(
                "productLabelingInfoRequirements",
                "safeUsageGuidelines",
                e.target.value
              )
            }
            error={errors.safeUsageGuidelines}
            helperText={errors.safeUsageGuidelines}
            disabled={disabled}
          />

          <SectionHeading text="iv. Instructions for the disposal of the product and its environmental or social impacts?" />
          <CustomTextField
            value={
              formData.productLabelingInfoRequirements.disposalInstructions
            }
            onChange={(e) =>
              handleNestedInputChange(
                "productLabelingInfoRequirements",
                "disposalInstructions",
                e.target.value
              )
            }
            error={errors.disposalInstructions}
            helperText={errors.disposalInstructions}
            disabled={disabled}
          />

          <SectionHeading text="v. Other (please specify)?" />
          <CustomTextField
            value={formData.productLabelingInfoRequirements.other}
            onChange={(e) =>
              handleNestedInputChange(
                "productLabelingInfoRequirements",
                "other",
                e.target.value
              )
            }
            error={errors.other}
            helperText={errors.other}
            disabled={disabled}
          />
        </Box>

        <SectionHeading
          text="b. What percentage of significant product or service categories are covered by these procedures and assessed for compliance?"
          sx={{ marginTop: "2rem" }}
        />
        <Box sx={{ width: "15%" }}>
          <CustomTextField
            value={formData.complianceRateProductCategories}
            onChange={(e) =>
              handleInputChange(
                "complianceRateProductCategories",
                e.target.value
              )
            }
            error={errors.complianceRateProductCategories}
            helperText={errors.complianceRateProductCategories}
            placeholder={"%"}
            disabled={disabled}
          />
        </Box>

        {/* Submit Button */}
      

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )

  return (
     <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI417_1;
